import useTranslation from "next-translate/useTranslation"
interface IProps {
  items: string[]
}

/**
 * This component provides the navigation in the public project profile.
 */
const PublicProfileNavigation: React.FC<IProps> = ({ items }: IProps) => {
  const { t } = useTranslation("common")

  return <nav className="public-project-profile__nav">
    <ul>
      {items.filter(item => !!item).map((item, i) =>
        <li key={`public-project-profile__nav-item-${i}`}>
          <a href={`#${item}`}>
            {t(`project.${item}.label`)}
          </a>
        </li>
      )}
    </ul>
  </nav>
}

export default PublicProfileNavigation
